export class Branch {
  id?: number;

  label?: string;

  constructor(data = {}) {
    Object.assign(this, data);
  }
}
